import {showMessage} from 'exsportia-components'
import {AxiosError} from 'axios'

import {l} from '../utils/i18n'

type BlockedErrorResponse = {
  type?: string
  message?: string
}

export const isContactBlockedError = (error: AxiosError<unknown>): boolean => {
  const data = error?.response?.data as BlockedErrorResponse | undefined
  return error?.response?.status === 403 && data?.type === 'CONTACT_BLOCKED'
}

export const showBlockedMessage = (): void => {
  showMessage(l('contactBlockedMessage'), 'error')
}
